import palette from "../../../styles/palette";

export default {
    card: {
        textAlign: "left",
        height: "100%",
        display: "flex",


    } as React.CSSProperties,
    cardInner: {
        flex: "1 1 100%",
        display: "flex",
        paddingBottom: 20,

    } as React.CSSProperties,
    cardPadding: {
        position: "relative",
        display: "flex",
        flex: "1 1 100%",
        padding: 20,
        borderRadius: 5,
        backgroundColor: "white",

    } as React.CSSProperties,
    alignCenter: {
        alignContent: "center",
        justifyContent: "center",
        alignItems: "center"
    } as React.CSSProperties,
    cardLabel: {
        position: "absolute",
        left: 10,
        top: -15,
        backgroundColor: "white",
        color: palette.text.primary,
        fontSize: 20,
        fontWeight: 700,
        paddingLeft: 10,
        paddingRight: 10

    } as React.CSSProperties,
}